/**
 * Admin token storage helpers (localStorage-backed).
 *
 * Phase: 4
 *
 * TRADEOFF: storing the JWT in localStorage exposes it to XSS. The alternative
 * (HttpOnly cookie) is XSS-safe but requires CSRF handling. For single-tenant
 * low-volume admin use, localStorage is the simpler default. If the admin
 * surface ever grows, reconsider.
 */

const TOKEN_KEY = "maskder.admin.token";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated(): boolean {
  return getToken() !== null;
}
